<template>
  <layout-main-inner title="考试详情">
    <div slot="action">
      <button-back />
    </div>
    <layout-card-wrap hasSlot>
      <template slot="title">考试信息</template>
      <template slot="form">
        <el-button
          type="primary"
          @click="updateitem">
          编辑
        </el-button>
      </template>
      <el-form
        v-loading="loading"
        label-position="top"
        label-width="110px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="考试名称：">
              {{ info.courseExamName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考试时间：">
              {{ info.examTime }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考试人数：">
              {{ info.passedUserCount + info.notPassedUserCount }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="是否可查成绩：">
              {{ info.queryScoreStatus === 1 ? '是': '否' }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
    <course-score-table
      :courseExamId="$route.query.courseExamId"
      :callback="getcourseexam" />
    <edit-score-modal
      ref="score"
      :callback="() => { getcourseexam() }"
    />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import CourseScoreTable from './course-score-table.vue'
import EditScoreModal from './edit-score-modal.vue'

export default {
  name: 'LuxuryCourseScoreDetail',
  components: { EditScoreModal, CourseScoreTable },
  data() {
    return {
      loading: false,
      info: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    if (this.$route.query.courseExamId) {
      this.getcourseexam()
    }
  },
  methods: {
    updateitem() {
      const row = this.info
      this.$refs.score.update({
        courseExamId: row.courseExamId,
        courseExamName: row.courseExamName,
        examTime: row.examTime,
        queryScoreStatus: row.queryScoreStatus
      })
    },
    getcourseexam() {
      this.loading = true
      this.$store.dispatch('account/getcourseexam', {
        payload: this.$route.query,
        success: (res) => {
          this.loading = false
          this.info = {
            ...res.data
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
